<abp-page [title]="'Inventory::Providers' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.Providers.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewProvider' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="nameFilter">
                {{ 'Inventory::Name' | abpLocalization }}
              </label>

              <input
                id="nameFilter"
                class="form-control"
                [(ngModel)]="filters.name"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="descriptionFilter">
                {{ 'Inventory::Description' | abpLocalization }}
              </label>

              <input
                id="descriptionFilter"
                class="form-control"
                [(ngModel)]="filters.description"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="addressFilter">
                {{ 'Inventory::Address' | abpLocalization }}
              </label>

              <input
                id="addressFilter"
                class="form-control"
                [(ngModel)]="filters.address"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="contactFilter">
                {{ 'Inventory::Contact' | abpLocalization }}
              </label>

              <input
                id="contactFilter"
                class="form-control"
                [(ngModel)]="filters.contact"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.Providers.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.Providers.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Name' | abpLocalization }}" prop="name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Description' | abpLocalization }}" prop="description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Address' | abpLocalization }}" prop="address">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.address }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Contact' | abpLocalization }}" prop="contact">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.contact }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewProvider') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="provider-name">
            {{ 'Inventory::Name' | abpLocalization }} *
          </label>

          <input
            id="provider-name"
            formControlName="name"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="provider-description">
            {{ 'Inventory::Description' | abpLocalization }} 
          </label>

          <input
            id="provider-description"
            formControlName="description"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="provider-address">
            {{ 'Inventory::Address' | abpLocalization }} 
          </label>

          <input
            id="provider-address"
            formControlName="address"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="provider-contact">
            {{ 'Inventory::Contact' | abpLocalization }} 
          </label>

          <input
            id="provider-contact"
            formControlName="contact"
            class="form-control"
          />
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
